import { useTranslation } from 'react-i18next'
import { Section } from '../Layout/Elements'
import {
  Inner,
  Title,
  Content,
} from './Elements'
import ScheduleItem from './ScheduleItem'

const ScheduleContainer = ({ data }) => {

  const { t } = useTranslation(data)
  const items = t('items', { returnObjects: true })

  return (
    <Section bgColor='var(--bg-soft-gray)'>
      <Inner>
        <Title>{t('title')}</Title>
        <Content>
          {
            items.map((item, index) => {
              return (
                <ScheduleItem key={index} item={item}/>
              )
            })
          }
        </Content>
      </Inner>
    </Section>
  )
}

export default ScheduleContainer